import { render } from "./HomeTestimonialsView.vue?vue&type=template&id=4979eb34&scoped=true"
import script from "./HomeTestimonialsView.vue?vue&type=script&lang=js"
export * from "./HomeTestimonialsView.vue?vue&type=script&lang=js"

import "./HomeTestimonialsView.vue?vue&type=style&index=0&id=4979eb34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4979eb34"]])

export default __exports__